export enum DwellingEquipmentType {
  AIR_CONDITIONER = 'AIR_CONDITIONER',
  COLD_WATER = 'COLD_WATER',
  HEATER = 'HEATER',
  HOT_WATER = 'HOT_WATER'
}

export enum DwellingEquipmentTypeLabel {
  AIR_CONDITIONER = 'Climatisation',
  COLD_WATER = 'Eau froide',
  HEATER = 'Chauffage',
  HOT_WATER = 'Eau chaude'
}

export enum DwellingInventoryType {
  MAKE_INVENTORY = 'MAKE_INVENTORY',
  PROVIDE_INVENTORY = 'PROVIDE_INVENTORY',
  PROVIDE_INVENTORY_LATER = 'PROVIDE_INVENTORY_LATER'
}

export enum DwellingInventoryTypeLabel {
  MAKE_INVENTORY = 'Je réalise mon inventaire ',
  PROVIDE_INVENTORY = 'Je fournirai l’inventaire plus tard',
  PROVIDE_INVENTORY_LATER = 'Je fournis mon inventaire'
}
